import React, { Dispatch, SetStateAction } from 'react';
import { DashlineSeparator } from '../../../common/CommonStyle';
import { getBrowserDetails } from '../../../../utils/helpers';
import {
  ImageStyle,
  ImageWrapper,
  InstructionContainer,
  ListContainer,
  Title,
  linkStyle,
  refreshBtnStyle,
} from './CameraPermissionStyle';
import PageInfoIcon from '../../../../atoms/icons/PageInfoIcon';
import TextLink from '../../../common/TextLink';
import JoinActionButton from '../../JoinActionButton';
import JoinSkipButton from '../../JoinSkipButton';
import colors from '../../../../theme/colors';
import { StepDescription } from '../SelfieVerificationStyle';
import { s3BucketContentDir } from '../../../../config/Master';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface DesktopInstructionProps {
  isJoinFlow: boolean;
  handleBackButtonClick: () => void;
  setShowQRCodeModal: Dispatch<SetStateAction<boolean>>;
}
const DesktopInstruction: React.FC<DesktopInstructionProps> = ({
  isJoinFlow,
  handleBackButtonClick,
  setShowQRCodeModal,
}) => {
  const { isSafari } = getBrowserDetails();

  const { isSVWallByGetSelfieVerified } = useSelector((state: RootState) => state.profile);
  const uploadSnackbar = useSelector((state: RootState) => state.uploadSnackbar);

  const handleShowQRCodeModal = () => {
    setShowQRCodeModal(true);
  };

  const handleRefreshClick = () => {
    if (uploadSnackbar?.items?.length > 0 && !uploadSnackbar?.items?.every(item => item.status === 'success')) {
      const confirmLeave = window.confirm(
        'Leave Site?\n\nPhotos are still being uploaded. Leaving the page now may result in unsaved files.'
      );

      if (!confirmLeave) return;
      window.location.reload();
    } else if (uploadSnackbar?.items?.length === 0 || uploadSnackbar?.items?.every(item => item.status === 'success')) {
      window.location.reload();
    }
  };

  return (
    <>
      <StepDescription isJoinFlow={isJoinFlow} style={{ margin: 0 }}>
        We must have camera access to continue the verification process. Please review the instructions below on how to
        grant this device access.
      </StepDescription>
      <DashlineSeparator style={{ width: '100%' }} />
      <InstructionContainer isJoinFlow={isJoinFlow}>
        <Title>Instructions to grant camera access</Title>
        {isSafari ? (
          <ListContainer isJoinFlow={isJoinFlow}>
            <li>Click settings icon on the left in the URL bar and select “Website Settings”</li>
            <li>Locate “Camera” and set to “Allow” in the dropdown</li>
            <li>Do this for “Microphone” as well</li>
            <li>Refresh the browser when done</li>
          </ListContainer>
        ) : (
          <ListContainer isJoinFlow={isJoinFlow}>
            <li>
              Click{' '}
              <span style={{ verticalAlign: 'middle' }}>
                <PageInfoIcon />
              </span>{' '}
              icon on the left in the URL bar and select “Site Settings”
            </li>
            <li>Under “Permissions,” locate “Camera” and set to “Allow” in the dropdown</li>
            <li>Do this for “Microphone” as well</li>
            <li>Refresh the browser when done</li>
          </ListContainer>
        )}
      </InstructionContainer>
      <InstructionContainer isJoinFlow={isJoinFlow}>
        <Title>
          or scan this {/* @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389} */}
          <TextLink style={linkStyle} onClick={handleShowQRCodeModal}>
            QR code
          </TextLink>{' '}
          to continue on another device
        </Title>
      </InstructionContainer>
      <ImageWrapper>
        <ImageStyle
          src={
            isSafari
              ? `${s3BucketContentDir}sv/Safari-Instructions.png`
              : `${s3BucketContentDir}sv/desktop-chrome-instructions.png`
          }
          alt="permission_instruction"
        />
      </ImageWrapper>
      <DashlineSeparator style={{ width: '100%' }} />
      <div style={{ textAlign: 'center' }}>
        <JoinActionButton label="Refresh" isDefault={true} onClick={handleRefreshClick} customStyle={refreshBtnStyle} />

        <JoinSkipButton
          label={isSVWallByGetSelfieVerified ? 'Cancel' : 'Back'}
          customStyle={{ color: colors.gray['1100'] }}
          onClick={handleBackButtonClick}
        />
      </div>
    </>
  );
};

export default DesktopInstruction;
